import { StyleSheet } from "@react-pdf/renderer";

export const debitCardReceiptPdfStyle = StyleSheet.create({
  page: {
    fontSize: 16,
  },
  header: {
    borderBottom: "1pt solid #D6D6D6",
    padding: "24 40",
  },
  headerImage: {
    width: 164,
  },
  main: {
    padding: 40,
  },
  title: {
    fontSize: 24,
  },
  card: {
    marginTop: 32,
    padding: 16,
    backgroundColor: "#F2F2F2",
    display: "flex",
    flexDirection: "row",
  },
  cardImage: {
    width: 52,
    height: 44,
    marginRight: 16,
  },
  cardEnding: {
    marginTop: 8,
  },
  table: {
    marginTop: 32,
    padding: 16,
    border: "1pt solid #D6D6D6",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 24,
  },
  firstRow: {
    paddingTop: 0,
  },
  label: {
    width: 280,
  },
  value: {
    width: 180,
  },
});
